import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23fe7dda&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=23fe7dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe7dda",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainCategoryCard: require('/workspace/components/MainCategoryCard.vue').default,PopularCategoryCard: require('/workspace/components/PopularCategoryCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
